import styled from 'styled-components';
import sizeStandards from '../../../Style-guide/size-standards';

const ProfilePageWrapper = styled.div`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${sizeStandards.screen.XL}px) {
    margin-bottom: 2vh;
  }
  @media screen and (max-width: ${sizeStandards.screen.LG}px) {
    margin-bottom: 6vh;
  }

  .profile-title {
    margin: 20px 0;
  }

  .profile-form {
    text-align: center;

    button[type='submit'] {
      margin-top: 20px;
      padding: 4px 16px;
    }
  }

  .profile-container {
    max-width: 550px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .input-group {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin: 0 20px;

    @media only screen and (max-width: ${sizeStandards.screen.XS}px) {
      width: 100%;
    }

    .input-field {
      margin-bottom: 20px;
      width: 100%;

      @media only screen and (max-width: ${sizeStandards.screen.XS}px) {
        max-width: 320px;
      }
    }
  }

  .delete-account-btn {
    /* max-width: 160px; */
    width: 100%;
    margin-top: 20px;

    @media screen and (min-width: ${sizeStandards.screen.LG}px) {
      p {
        font-size: ${sizeStandards.font.XS}px;
      }
    }
  }

  .delete-account-modal {
    white-space: pre-line;

    .confirmation-text {
      line-height: 1.5;
    }
  }
`;

export default ProfilePageWrapper;
